import { useCallback, useState } from 'react';

export function useOptimisticState<T>(initialValue: T) {
  const [state, setState] = useState<T>(initialValue);

  const setOptimisticState = useCallback(
    (value: T | ((prevState: T) => T), fn: () => Promise<void>) => {
      (async () => {
        const prevValue = state;

        setState(value);

        try {
          await fn();
        } catch {
          setState(prevValue);
        }
      })();
    },
    [state]
  );

  return [state, setOptimisticState] as const;
}
